// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { FinancialDataTooltipComponent } from '../tooltip/financial-data-tooltip.component';
import { FinancialDataEditLinkComponent } from '../edit-link/financial-data-edit-link.component';
import { IbanSelectorComponent } from '../../../iban-selector/iban-selector.component';
// Hooks
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
// Styles
import {
  FinancialDataPaymentMethodContainerStyled,
  FinancialDataPaymentMethodNameStyled,
  FinancialDataPaymentMethodQuantityStyled,
} from './financial-data-payment-method.component.styled';
// Types
import { FinancialDataPaymentMethodComponentType } from './types/financial-data-payment-method.component.type';
// Utils
import { getPaymentMethodTranslation } from './utils/financial-data-payment-method.utils';

const FinancialDataPaymentMethodComponent = ({
  detail,
  handleCloseIbanSelector,
  handleSaveChangedIban,
  showTooltip,
  showLink,
  setShowIbanSelector,
  showIbanSelector,
}: FinancialDataPaymentMethodComponentType): React.JSX.Element => {
  const { flowApiData } = useLayoutContextConsumerHook();

  return !showIbanSelector ? (
    <FinancialDataPaymentMethodContainerStyled key={detail.label}>
      <FinancialDataPaymentMethodNameStyled>
        <FormattedMessage id={detail.label} />
        {showTooltip && <FinancialDataTooltipComponent />}
      </FinancialDataPaymentMethodNameStyled>
      <FinancialDataPaymentMethodQuantityStyled>
        {getPaymentMethodTranslation(flowApiData)}
        {showLink && <FinancialDataEditLinkComponent setShowIbanSelector={setShowIbanSelector} />}
      </FinancialDataPaymentMethodQuantityStyled>
    </FinancialDataPaymentMethodContainerStyled>
  ) : (
    <IbanSelectorComponent onCancel={handleCloseIbanSelector} onContinue={handleSaveChangedIban} />
  );
};
export { FinancialDataPaymentMethodComponent };
